import { createContext } from 'react';
import { defaultPriceStrategy } from 'appConstants/dishes';
import { IItemForGetShortInfo, TLanguageIDs, IMenuTranslation, IDefaultLanguage, TPriceStrategy } from 'types';

export type TTypeOfModalWindow = Nullable<'defaultTranslationIsEmpty'>;

export interface IEditPortionState {
	portionId: string;
	nameOfPortion: string;
	fetchedCustomers: IItemForGetShortInfo[];
	IDSelectedCustomer: Nullable<string>;
	fetchedRestaurants: IItemForGetShortInfo[];
	IDSelectedRestaurant: Nullable<string>;
	nameOfDish: string;
	dishId: string;
	posName: Nullable<string>;
	articleNumber: Nullable<string>;
	isCreatedOnPos: boolean;
	price: Nullable<number>;
	priceStrategy: TPriceStrategy;
	externalId: string;
	isProtectedFromSync: boolean;
	isDisabled: boolean;
	defaultCustomerLanguage: Nullable<IDefaultLanguage>;
	selectedTranslationTab: Nullable<TLanguageIDs>;
	translations: IMenuTranslation[];
	selectedAdditionalRestaurants: string[];
	typeOfModalWindow: TTypeOfModalWindow;
}

export const editPortionInitialState: IEditPortionState = {
	portionId: '',
	nameOfPortion: '',
	fetchedCustomers: [],
	IDSelectedCustomer: null,
	fetchedRestaurants: [],
	IDSelectedRestaurant: null,
	nameOfDish: '',
	dishId: '',
	posName: null,
	articleNumber: null,
	isCreatedOnPos: false,
	price: null,
	priceStrategy: defaultPriceStrategy,
	externalId: '',
	isProtectedFromSync: false,
	isDisabled: false,
	defaultCustomerLanguage: null,
	selectedTranslationTab: null,
	translations: [],
	selectedAdditionalRestaurants: [],
	typeOfModalWindow: null,
};

export interface IEditPortionContext extends IEditPortionState {
	changeNameOfPortion(value: string): void;
	changePrice(value: Nullable<number>): void;
	changePriceStrategy(value: TPriceStrategy): void;
	changeExternalId(value: string): void;
	generateUniqueExternalId(): void;
	toggleIsProtectedFromSync(): void;
	toggleIsDisabled(): void;
	setTranslationTab(value: Nullable<TLanguageIDs>): void;
	changeNameTranslation(languageId: TLanguageIDs, value: string): void;
	setAdditionalRestaurants(value: string[]): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
}

export const EditPortionContext = createContext<IEditPortionContext>({
	changeNameOfPortion: () => undefined,
	changePrice: () => undefined,
	changePriceStrategy: () => undefined,
	changeExternalId: () => undefined,
	generateUniqueExternalId: () => undefined,
	toggleIsProtectedFromSync: () => undefined,
	toggleIsDisabled: () => undefined,
	setTranslationTab: () => undefined,
	changeNameTranslation: () => undefined,
	setAdditionalRestaurants: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	...editPortionInitialState,
});
